import React from 'react';
import Head from 'next/head';

import { WEBSITE_CDN } from 'utils/config';

interface TwitterTagsProps {
  url: string;
  title: string;
  desc?: string;
}

const TwitterTags = ({ url, title, desc }: TwitterTagsProps) => {
  return (
    <Head>
      <meta name="twitter:title" content={`${title} - Spotify`} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@SpotifyCares" />
      <meta name="twitter:creator" content="@SpotifyCares" />
      <meta name="twitter:image" content={`${WEBSITE_CDN}/open-graph-default.png`} />
      <meta name="twitter:url" content={url} />
      {desc && <meta name="twitter:description" content={desc} />}
    </Head>
  );
};

export default TwitterTags;
